<template>
  <v-container fluid class="contact">
    <v-row>
      <v-col class="text-center" :cols="$vuetify.breakpoint.smAndDown ? 12 : 6">
        <v-avatar
          class="elevation-12 mb-12"
          size="148"
        >
          <v-img src="../images/logo.jpeg"/>
        </v-avatar>
        <v-card-title class="title font-weight-light ">
          <span class="mx-auto">Мария Юдина</span>
        </v-card-title>

        <v-col>
          <v-btn fab small dark @click="openLink('https://vk.com/psychology_chair')">
            <img src="../../public/icons/vk.png" height="30" width="30"/>
          </v-btn>
          <v-btn icon fab small dark @click="openLink('https://wa.me/+79160532493')">
            <img src="../../public/icons/whatsup.png" height="30" width="30"/>
          </v-btn>
          <v-btn fab small dark @click="openLink('mailto:yudina_maria.psy@mail.ru')">
            <img src="../../public/icons/mail.png" height="30" width="30"/>
          </v-btn>
          <v-btn fab small dark @click="openLink('https://t.me/psychology_chair')">
            <img src="../../public/icons/telegram.png" height="30" width="30"/>
          </v-btn>
        </v-col>
      </v-col>

      <v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 6" class="d-flex justify-center">
        <Links class="my-auto"/>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
import Links from "./Links";

export default {
  name: "Footer",
  components: {
    Links
  },
  methods: {
    openLink(link) {
      const win = window.open(link, '_blank');
      win.focus();
    },
  }
}
</script>

<style scoped>
.contact {
  background: #212121;
  color: #d6d6d6;
}
</style>
